module.exports = __webpack_public_path__ + "static/media/fitTrack.3ec223e4.png";